import { useRouter } from "next/router";
import AppSidebar from "./app-sidebar";
import SideBar from "./sidebar";
import MainMenuItems from "./main-menu-items";
import NavMenuItems from "./nav-menu-items";
import BottomNav from "./bottom-nav";
import FullScreenLayout from "./full-screen-layout";
import MainBodyLayout from "./main-body-layout";
import { BusinessProvider } from "/contexts/business-context";
import { UserProvider } from "/contexts/user-context";
import { SideBarProvider } from "../../contexts/side-bar-context";
import Loader from "../ui/loader";
import Notification from "../ui/notification";
import { ThemeProvider } from "next-themes"
import { TableProvider } from "../../contexts/table-context";
import { PegsProvider } from "../../contexts/pegs-context";
import { TableFilterProvider } from "../../contexts/table-filter-context";

export default function Shell({ children }) {
  const router = useRouter();
  const isOnboarding = router.pathname === '/[uuid]/onboarding';

  return (
    <>
      <UserProvider>
        <BusinessProvider>
          <TableProvider>
            <TableFilterProvider>
              <PegsProvider>
                <Loader>
                  <SideBarProvider>
                    <ThemeProvider>
                      <FullScreenLayout>
                        {isOnboarding ? (
                          <AppSidebar />
                        ) : (
                          <SideBar>
                            <MainMenuItems>
                              <NavMenuItems />
                            </MainMenuItems>
                            <BottomNav />
                          </SideBar>
                        )}
                        <MainBodyLayout>
                          {children}
                        </MainBodyLayout>
                      </FullScreenLayout>
                    </ThemeProvider>
                  </SideBarProvider>
                </Loader>
              </PegsProvider>
            </TableFilterProvider>
          </TableProvider>
        </BusinessProvider>
      </UserProvider>
      <Notification />
    </>
  );
}
